import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import AddMoreDataButton from '../../../../components/addMoreDataButton/AddMoreDataButton';
import RemovableItem from '../../RemovableItem/RemovableItem';

import editDocumentActions from '../../store/actions/edit-document.actions';
import { actions as newDocumentActions } from '../../store/actions/new-document.actions';
import documentEditMode from '../../constants/documentEditMode';
import useUserRoleInDoc from '../../hooks/useUserRoleInDoc';
import roles from '../../constants/roles';

const AddressesCell = memo(({ record, single, rowOpened }) => {
  const dispatch = useDispatch();
  const userRole = useUserRoleInDoc(record);
  // const allowChange = userRole === roles.RESPONSIBLE_OR_AUTHOR;
  const addAddress = useCallback(
    (e) => {
      e.stopPropagation();
      const clientAddress = record.clientAddress ? record.clientAddress : {};
      dispatch(newDocumentActions.applyAddrStreet(clientAddress.streetId));
      dispatch(newDocumentActions.applyAddrBuilding(clientAddress.houseId));
      dispatch(newDocumentActions.setAddrFlatValue(clientAddress.id));
      dispatch(
        editDocumentActions.openModal({
          ...record,
          editMode: documentEditMode.ADDRESS,
        })
      );
    },
    [record]
  );

  return (
    <>
      {single && (
        <OneAddress
          single={single}
          // allowDelete={record.adresses?.[0] && rowOpened && allowChange}
          allowDelete={record.adresses?.[0] && rowOpened}
          key={record.adresses?.[0]?.id || `${record.id}_no_address`}
          record={record}
          address={record.adresses?.[0]}
        />
      )}
      {!single &&
        rowOpened &&
        record.adresses?.length > 1 &&
        record.adresses?.slice(1).map((address) => (
          <OneAddress
            allowDelete={address && rowOpened}
            // allowDelete={address && rowOpened && allowChange}
            rowOpened={rowOpened}
            key={address.id}
            address={address}
            record={record}
          />
        ))}
      {/* {!single && rowOpened && allowChange && (
        <AddMoreDataButton text="Добавить адрес" onClick={addAddress} />
      )} */}
      {!single && rowOpened && (
        <AddMoreDataButton
          text="Добавить адрес"
          onClick={addAddress}
        />
      )}
    </>
  );
});

function OneAddress({ address, record, allowDelete, single }) {
  const dispatch = useDispatch();

  return (
    <RemovableItem
      single={single}
      allowDelete={allowDelete}
      record={record}
      itemText={address?.fullAddress || 'не указан'}
      onConfirm={() => dispatch(editDocumentActions.deleteAddress(address?.id))}
      deleteConfirmText="Удалить адрес?"
    />
  );
}

export default AddressesCell;
